import { render, staticRenderFns } from "./URegisterInfoEditComp.vue?vue&type=template&id=ad1b3a3a&scoped=true&"
import script from "./URegisterInfoEditComp.vue?vue&type=script&lang=ts&"
export * from "./URegisterInfoEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./URegisterInfoEditComp.vue?vue&type=style&index=0&id=ad1b3a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1b3a3a",
  null
  
)

export default component.exports